import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconH1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconH1"><Path fillRule="evenodd" clipRule="evenodd" d="M3.5 4V11.25H12.5V4H14V20H12.5V12.75H3.5V20H2V4H3.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M20.5987 10H21.9978V20H20.4978V12.1629L17.9696 14.5603L16.9375 13.4719L20.5987 10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconH1;
